/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RoleId } from "../../commons/types/RoleId";
import { AccountId } from "../../commons/types/AccountId";
export const RoleResponse = core.serialization.object({
    id: RoleId,
    name: core.serialization.string(),
    accountId: AccountId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
